import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import localization from '../../../shared/strings';
import { buildMasterVariantDisplayName } from '../helpers/buildMasterVariantDisplayName';
import styles from './styles.module.scss';

const l10n = localization.PRODUCT_INFO;

const VariantDetailsHeader = ({
  productTitle,
  availableOptions,
  variantOptions,
  variantDisplayName,
}) => {
  const displayName = useMemo(() => (
    variantDisplayName || buildMasterVariantDisplayName({
      productTitle,
      availableOptions,
      variantOptions,
    })
  ), [variantDisplayName, productTitle, availableOptions, variantOptions]);

  return (
    <div className={styles.header} data-qa="variantDetailsHeader">
      <div className={styles.entityType}>{l10n.entityTypeVariant}</div>
      <div className={styles.displayName} title={displayName}>{displayName}</div>
    </div>
  );
};

VariantDetailsHeader.propTypes = {
  productTitle: PropTypes.string,
  variantDisplayName: PropTypes.string,
  availableOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
  })),
  variantOptions: PropTypes.objectOf(PropTypes.string),
};

VariantDetailsHeader.defaultProps = {
  productTitle: '',
  variantDisplayName: '',
  availableOptions: [],
  variantOptions: {},
};

export default VariantDetailsHeader;
